import { render } from "./SocialLinks.vue?vue&type=template&id=7bc80b70&scoped=true"
import script from "../js/social-links.js?vue&type=script&lang=js"
export * from "../js/social-links.js?vue&type=script&lang=js"

import "./SocialLinks.vue?vue&type=style&index=0&id=7bc80b70&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc80b70"]])

export default __exports__